
export class Constants {
  static readonly ADAP_SHORT_DATE = 'MM/dd/yyyy';
  static readonly GUID_DEFAULT_VALUE = '00000000-0000-0000-0000-000000000000';
  static readonly USER_PHOTO_MINIATURE_SIZE = '48x48';
  static readonly REQUIRED_FIELD_ERROR: string = 'this field is required';
  static readonly REQUIRED_MAPPING_ERROR: string =
    'required,this field is required,maxLength,maximum length of field reached';
  static readonly YES = 'YES';
  static readonly NO = 'NO';
  static readonly NO_DATE_SET = '[no date set]';
  static readonly ITEMS_REQUIRED_YOUR_ATTENTION =
    'There are items that require your attention';
}

export class UserRoles {
  static readonly DA_ENGINEER = 'DAEngineer';
  static readonly CHAPTER_MANAGER = 'ChapterManager';
  static readonly SME = 'SME';
  static readonly PROJECT_CONTACT = 'ProjectContact';
}

export const UserRolesDisplayLabel: Map<string, string> = new Map([
  [UserRoles.DA_ENGINEER, 'Design Assurance'],
  [UserRoles.CHAPTER_MANAGER, 'Chapter Manager'],
  [UserRoles.SME, 'SME'],
  [UserRoles.PROJECT_CONTACT, 'Project Contact'],
]);

export const QUICKFILTER_INPUT_PLACEHOLDER = "i'm looking for...";

export class Colors {
  static readonly WHITE = 'white';
  static readonly BLUE = 'blue';
  static readonly BLUE_DARK = 'blue-dark';
  static readonly BLUE_SHADE_1 = 'blue-shades-1';
  static readonly BLUE_SHADE_2 = 'blue-shades-2';
  static readonly BLUE_SHADE_3 = 'blue-shades-3';
  static readonly BLUE_SHADE_4 = 'blue-shades-4';
  static readonly BLUE_SHADE_5 = 'blue-shades-5';
  static readonly GREEN_MEDIUM = 'green-medium';
  static readonly GREEN_DARK = 'green-dark';
  static readonly TEAL = 'teal';
  static readonly TEAL_SHADE_1 = 'teal-shades-1';
  static readonly TEAL_SHADE_2 = 'teal-shades-2';
  static readonly TEAL_SHADE_3 = 'teal-shades-3';
  static readonly TEAL_SHADE_4 = 'teal-shades-4';
  static readonly TEAL_SHADE_5 = 'teal-shades-5';
  static readonly ORANGE_LIGHT = 'orange-light';
  static readonly BURGUNDY = 'burgundy';
}

export class PageTitles {
  static readonly CHECKS = 'checks';
  static readonly PEER_POOL = 'peer pool';
  static readonly PROJECT_DELIVERABLES = 'project deliverables';
  static readonly RISK_ASSESSMENT = 'risk assessment';
  static readonly MATCHING_TOOL = 'matching tool';
  static readonly ALL_DELIVERABLES = 'all deliverables';
  static readonly ESTIMATE_PLAN = 'estimate plan';
  static readonly WORKPLAN_PREP = 'workplan prep';
  static readonly INFORMATION = 'information';
}
